import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { MyApp } from './app.component';

import { DebugPage } from '../pages/debug/debug';
import { LoginPage } from '../pages/login/login';
import { ReceiptsPage } from '../pages/receipts/receipts';
import { UserDetailsPage } from '../pages/user-details/user-details';
import { UsersPage } from '../pages/users/users';

import { Authentication } from '../providers/authentication';
import { MystopiaUsers } from '../providers/mystopia-users';
import { TokenRefresh } from '../providers/token-refresh';
import { TokenStorage } from '../providers/token-storage';
import { TokenVerify } from '../providers/token-verify';

@NgModule({
  declarations: [
    MyApp,
    DebugPage,
    LoginPage,
    UsersPage,
    UserDetailsPage,
    ReceiptsPage,
  ],
  imports: [
    IonicModule.forRoot(MyApp),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    DebugPage,
    LoginPage,
    UsersPage,
    UserDetailsPage,
    ReceiptsPage,
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    Authentication,
    MystopiaUsers,
    TokenRefresh,
    TokenStorage,
    TokenVerify,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts